import gql from "graphql-tag";

const DELETE_WALLET_MUTATION = gql`
    mutation deleteWallet(
        $id: String!
    ) {
        deleteWallet(
            deleteWalletInput: {
               id: $id
            }
        )   {
            id
        }
    }
`;

export default DELETE_WALLET_MUTATION;